var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"width":"100"}},[_c('v-card',{staticClass:"rounded-lg",attrs:{"height":"250"}},[_c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.data.img,"height":"250","width":"250","cover":""},on:{"click":function($event){return _vm.openLink(_vm.data.id)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }